import Stack from '@mui/material/Stack';
import {
  MintDatePanel,
  MintDatePanelProps,
} from 'src/components/minting/MintDatePanel';
import {
  MintGuidePanel,
  MintGuidePanelProps,
} from 'src/components/minting/MintGuidePanel';
import {
  MintDetailsPanel,
  MintDetailsPanelProps,
} from 'src/components/minting/MintDetailsPanel';

export type MintPanelsProps = MintDetailsPanelProps &
  MintDatePanelProps &
  MintGuidePanelProps;

export function MintPanels({
  mintDetails,
  startDate,
  endDate,
  steps,
}: MintPanelsProps) {
  return (
    <Stack direction="row" gap="16px" paddingX="64px" paddingY="16px">
      <MintDetailsPanel mintDetails={mintDetails} />
      <Stack gap="16px">
        <MintDatePanel startDate={startDate} endDate={endDate} />
        <MintGuidePanel steps={steps} />
      </Stack>
    </Stack>
  );
}
